var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFihg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63,
    height: 30,
    viewBox: "0 0 63 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BF0201",
    d: "M0 0v29.922h8.035V17.205h12.432v-5.984H8.035V5.984h12.432V0H0M21.983 0v29.922h11.37V29.8c-4.245-.626-6.367-4.366-5.306-8.855L33.353 0h-11.37"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#02408F",
    d: "M37.901 0l-3.79 20.945c-.606 3.292-.455 4.788 1.516 4.489 1.971-.3 2.123-2.544 3.79-2.244 1.668.299 2.426 1.496 2.274 2.992-.151 1.496-1.364 3.74-6.822 3.74h9.854V17.953h10.613v11.969h7.58V0h-7.58v11.22H44.723V0h-6.822z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFihg);
export default __webpack_public_path__ + "static/media/fihg.610232e67a0fd02d8d8d47428bfafabd.svg";
export { ForwardRef as ReactComponent };